<template>
    <modal :modal-id="modalId"
        :title="modalTitle"
        :preloader="preloader"
        @submit="submit"
        @close-modal="closeModal">

        <template slot="body">
            <app-overlay-loader v-if="preloader"/>
            <form class="mb-0"
                  :class="{'loading-opacity': preloader}"
                  ref="form" :data-url='selectedUrl ? `master/minimum-apps-value/${inputs.id}` : `master/minimum-apps-value`'>
                <div class="form-group row align-items-center">
                    <label for="inputs_apps_name" class="col-sm-3 mb-0">
                        Apps Name
                    </label>
                    
					<app-input
						id="inputs_apps_name"
						class="col-sm-9"
						type="search-select"
						v-model="inputs.apps_name"
						placeholder="Apps Name"
						:list="apps_list"
						:required="true"
					/>

                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_percentage" class="col-sm-3 mb-0">
                        Percentage
                    </label>
                    <app-input id="inputs_percentage"
                               class="col-sm-9"
                               type="number"
                               v-model="inputs.percentage"
                               placeholder="Percentage"
                               :required="true"/>

                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_percentage" class="col-sm-3 mb-0">
                        <br>
                    </label>
                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_percentage" class="col-sm-3 mb-0">
                        <br>
                    </label>
                </div>
            </form>
        </template>
    </modal>
</template>

<script>
    import {FormMixin} from "../../../../../core/mixins/form/FormMixin.js";
    import {ModalMixin} from "../../../../Mixins/ModalMixin";
    import {MINIMUM_APPS_VALUE} from "../../../../Config/ApiUrl.js";

    export default {
        name: "ModalForm",
        mixins: [FormMixin, ModalMixin],
        props: {
            tableId: String,
            formId: String,
        },
        data() {
            return {
                preloader: false,
                inputs: {
                    apps_name: null,
                    percentage: 0,
                },
                apps_list: [
                    { id: "Reading", value: "Reading" },
                    { id: "Meaning", value: "Meaning" },
                ],
                modalId: this.formId,
                modalTitle: this.$t('add'),
            }
        },
        created() {
            if (this.selectedUrl) {
                this.modalTitle = this.$t('edit');
                this.preloader = true;
            }
        },
        methods: {
            submit() {
                this.save(this.inputs);
            },
            afterSuccess(response) {
                this.$toastr.s(response.data.message);
                this.$hub.$emit('reload-' + this.tableId);
            },

            afterSuccessFromGetEditData(response) {
                if (response.data.phone) this.phone = response.data.phone;
                this.inputs = response.data;
                this.preloader = false;
            },
        },
    }
</script>
